import { MarketingPreference, MarketingPreferenceType } from 'cpie-common';
import { useAnalyticsActionTracker } from '@cp-shared-15/frontend-ui';
import React, { useState } from 'react';
import { Route, Switch, useHistory, useRouteMatch } from 'react-router';
import { useScrollToView } from '../../../../utils/use-scroll-to';
import { changeVWFSMarketingPreferencesPath } from '../../../navigation/paths';
import { CommonConsultView } from '../common/consult-view';
import { CommonEditView } from '../common/edit-view/CommonEditView';
import { EditStatus } from '../common/EditStatus';

export const VWFSSection: React.FC<{
    marketingPreference: MarketingPreference;
    isContactEmailDefined: boolean;
}> = ({ marketingPreference, isContactEmailDefined }) => {
    const history = useHistory();
    const { path } = useRouteMatch();
    const [lastEditStatus, setLastEditStatus] = useState<EditStatus>(EditStatus.NOT_PERFORMED);
    const { scrollToRef, setCurrentView } = useScrollToView(changeVWFSMarketingPreferencesPath());
    const { onAction: onEdit } = useAnalyticsActionTracker('onEditProfileConsentSettings');
    const { onAction: onCancel } = useAnalyticsActionTracker('onEditProfileCancel');

    const trackingSectionType = '(VWFS)';

    const startEditing = (): void => {
        onEdit(trackingSectionType);
        setLastEditStatus(EditStatus.NOT_PERFORMED);
        setCurrentView('EDIT_VIEW');
        history.push(changeVWFSMarketingPreferencesPath());
    };

    const finishEditing = (newEditStatus: EditStatus): void => {
        setLastEditStatus(newEditStatus);
        setCurrentView('CONSULT_VIEW');
        history.push(path);
    };

    const cancelEditing = (): void => {
        onCancel(`Consent settings ${trackingSectionType}`);
        setLastEditStatus(EditStatus.NOT_PERFORMED);
        setCurrentView('CONSULT_VIEW');
        history.push(path);
    };

    return (
        <section ref={scrollToRef}>
            <Switch>
                <Route exact path={changeVWFSMarketingPreferencesPath()}>
                    <CommonEditView
                        marketingPreference={marketingPreference}
                        cancelEditing={cancelEditing}
                        finishEditing={finishEditing}
                        marketingPreferenceType={MarketingPreferenceType.VWFS}
                        isContactEmailDefined={isContactEmailDefined}
                    />
                </Route>
                <Route path={path}>
                    <CommonConsultView
                        marketingPreferenceType={MarketingPreferenceType.VWFS}
                        marketingPreference={marketingPreference}
                        startEditing={startEditing}
                        lastEditStatus={lastEditStatus}
                    />
                </Route>
            </Switch>
        </section>
    );
};
